export const DATE_OPTIONS = [
  { label: "Today", value: "1D" },
  { label: "Week", value: "1W" },
  { label: "Month", value: "1M" },
  { label: "3 Months", value: "3M" },
  { label: "6 Months", value: "6M" },
  { label: "Year", value: "" },
];
